// AUTO-СГЕНЕРИРОВАНО из branding/fleet/rumb/brandbook/assets/icons/ocean.svg — не править вручную.
// Инлайн-спрайт «Румб · Аналитика»: моноцветные эмблемы (currentColor, без свечения).
// Монтируется один раз в AppLayout → <use href="#ic-..."/> резолвится по всему приложению.
const SPRITE = `<svg xmlns="http://www.w3.org/2000/svg" style="display:none">

<defs>
  
  <symbol id="ic-sec-maps" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 6 L9.5 4 L15 6 L20 4 V18 L15 20 L9.5 18 L4 20 Z"/><path d="M9.5 4 V18 M15 6 V20"/>
  </symbol>
  <symbol id="ic-sec-models" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 4 V19 H20"/><path d="M6 16 C9 16 10 9 13 10 C15.5 10.8 17 7.5 19 6"/>
    <circle cx="9" cy="13.7" r="1" fill="currentColor"/><circle cx="13" cy="10" r="1" fill="currentColor"/><circle cx="19" cy="6" r="1" fill="currentColor"/>
  </symbol>
  <symbol id="ic-sec-buoys" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3v6" />
    <path d="M9 15a3 3 0 0 1 6 0" />
    <path d="M7.5 15h9l-1.2 3.2a2 2 0 0 1-1.9 1.3h-2.8a2 2 0 0 1-1.9-1.3Z" />
    <path d="M3 21c1.2-.9 2.3-.9 3.5 0M17.5 21c1.2-.9 2.3-.9 3.5 0" />
  </symbol>
  <symbol id="ic-sec-imagery" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2"/>
    <path d="M3 15.5 L8 11 L11.5 14"/>
    <path d="M13 16 L16.5 12.5 L21 16.5"/>
    <circle cx="15.5" cy="9" r="1.6"/>
  </symbol>
  <symbol id="ic-sec-satellites" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 6 Q12 3.2 17 6"/>
    <rect x="10.2" y="10" width="3.6" height="5" rx="0.8"/>
    <path d="M10.2 12.5 H7.6 M13.8 12.5 H16.4"/>
    <rect x="3.6" y="10.1" width="4" height="4.8" rx="0.5"/><rect x="16.4" y="10.1" width="4" height="4.8" rx="0.5"/>
    <path d="M5.6 10.1 V14.9 M18.4 10.1 V14.9"/>
  </symbol>
  <symbol id="ic-sec-rules" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6 3.5 H15 L19 7.5 V20.5 H6 Z"/><path d="M15 3.5 V7.5 H19"/>
    <path d="M9 11 H16 M9 14 H16 M9 17 H13"/>
  </symbol>
  <symbol id="ic-sec-navwarn" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3.5 L19 15.5 H5 Z"/><path d="M12 8 V11.5 M12 13.5 V13.6"/>
    <path d="M3 19.5 C5 18 7 18 9 19.5 C11 21 13 21 15 19.5 C17 18 19 18 21 19.5"/>
  </symbol>
  <symbol id="ic-sec-quotas" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 4 V12 L18.9 16"/><circle cx="12" cy="12" r="8"/>
  </symbol>
  <symbol id="ic-sec-prices" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 19.5 H20"/><path d="M4.5 15.5 L9 11 L12.5 13.5 L19.5 6.5"/><path d="M15.5 6.5 H19.5 V10.5"/>
  </symbol>
  <symbol id="ic-sec-reports" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 6.5 H11"/><path d="M4 12 H8"/><path d="M4 17.5 H14"/><path d="M11 6.5 H16" stroke-dasharray="1.6 1.9"/><path d="M8 12 H20" stroke-dasharray="1.6 1.9"/>
  </symbol>
  <symbol id="ic-sec-settings" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 7.5 H20 M4 12 H20 M4 16.5 H20"/><circle cx="9" cy="7.5" r="2.1"/><circle cx="15" cy="12" r="2.1"/><circle cx="7.5" cy="16.5" r="2.1"/>
  </symbol>

  
  <symbol id="ic-sst" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10.2 6 a1.8 1.8 0 0 1 3.6 0 V13.4 a3.2 3.2 0 1 1 -3.6 0 Z"/>
    <circle cx="12" cy="16.4" r="1.3" fill="currentColor"/><path d="M14 8.4 H15.4 M14 11 H15.4"/>
  </symbol>
  <symbol id="ic-salinity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3.5 C12 3.5 6.5 10 6.5 14 A5.5 5.5 0 0 0 17.5 14 C17.5 10 12 3.5 12 3.5 Z"/>
    <path d="M9.6 13 l1 1 -1 1 -1 -1 Z" fill="currentColor"/><path d="M13.4 12 l1 1 -1 1 -1 -1 Z" fill="currentColor"/><path d="M11.8 15.6 l1 1 -1 1 -1 -1 Z" fill="currentColor"/>
  </symbol>
  <symbol id="ic-oxygen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="9.8" cy="16.2" r="1.7"/><circle cx="14.3" cy="12" r="2.4"/><circle cx="10.8" cy="7.6" r="1"/>
  </symbol>
  <symbol id="ic-chlorophyll" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6.5 17.5 C6.5 11 11.5 6.5 18 6.5 C18 13 13 17.5 6.5 17.5 Z"/><path d="M6.5 17.5 C10 14.5 14.5 10 18 6.5"/>
  </symbol>
  <symbol id="ic-zooplankton" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M16 6.5 C11 6 7.5 9.5 7.5 13.5 C7.5 16.5 9.5 18.6 12.6 18 C10.8 16.4 10.9 13.4 12.1 11 C13.1 9 14.5 7.5 16 6.5 Z"/>
    <circle cx="14.2" cy="8.4" r="0.7" fill="currentColor"/>
    <path d="M16 6.5 C17.5 5.6 18.6 5.3 19.6 4.7 M15.1 7.6 C16.7 6.9 17.8 6.7 18.8 6.4"/>
    <path d="M9.6 14.6 L8.3 15.9 M10.5 16.1 L9.5 17.5 M11.8 16.9 L11.1 18.5"/>
  </symbol>
  <symbol id="ic-currents" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 9 C6.5 6 8.5 12 11.5 9 C14.5 6 16.5 12 19.5 9"/><path d="M17.6 7.4 L19.8 9 L17.6 10.6"/>
    <path d="M3.5 15 C6.5 12 8.5 18 11.5 15 C14.5 12 16.5 18 19.5 15"/><path d="M17.6 13.4 L19.8 15 L17.6 16.6"/>
  </symbol>
  <symbol id="ic-ssha" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 8.5 q4 -3 8 0 t8 0"/><path d="M4 15 H20" stroke-dasharray="2 2.4"/><path d="M12 9.5 V14"/><path d="M10.8 10.7 L12 9.5 L13.2 10.7"/><path d="M10.8 12.8 L12 14 L13.2 12.8"/>
  </symbol>
  <symbol id="ic-wind" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 8.5 H14 a2.4 2.4 0 1 0 -2.4 -2.4"/><path d="M4 12.5 H18 a2.2 2.2 0 1 1 -2.2 2.2"/><path d="M4 16.5 H11.5 a2 2 0 1 0 -2 -2"/>
  </symbol>
  <symbol id="ic-bathymetry" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 6.5 H20.5"/>
    <path d="M3.5 13 C6 13 6.5 16.6 9 17 C11 17.3 12 14 14.5 14 C17 14 18 16 20.5 15.4"/>
    <path d="M17.4 6.5 V11.4 M16.3 9.9 L17.4 11.4 L18.5 9.9"/>
  </symbol>

  
  <symbol id="ic-ice" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3 V21 M4.2 7.5 L19.8 16.5 M19.8 7.5 L4.2 16.5"/>
    <path d="M12 6.4 L10.2 5.2 M12 6.4 L13.8 5.2 M12 17.6 L10.2 18.8 M12 17.6 L13.8 18.8"/>
  </symbol>
  <symbol id="ic-fog" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 8 H18 M4 11.5 H20 M6 15 H17"/><path d="M4 19 q4 -1.6 8 0 t8 0"/>
  </symbol>
  <symbol id="ic-clouds" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 18 h8.5 a3.5 3.5 0 0 0 0.4 -6.98 A5.2 5.2 0 0 0 7 11.4 A3.2 3.2 0 0 0 8 18 Z"/>
  </symbol>
  <symbol id="ic-earthquakes" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 12 H7 L8.6 7 L10.6 16.5 L12.4 9.5 L13.8 13.5 L15.2 11.5 H20.5"/>
  </symbol>
  <symbol id="ic-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M16 4.5 A8 8 0 1 0 16 19.5 A6.2 6.2 0 1 1 16 4.5 Z"/>
  </symbol>

  
  <symbol id="ic-hsi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 17 A8 8 0 0 1 20 17"/><path d="M4 17 H20"/>
    <path d="M12 17 L15.6 11.4"/><circle cx="12" cy="17" r="1.2" fill="currentColor"/>
    <path d="M6.6 10.6 l0.9 0.9 M17.4 10.6 l-0.9 0.9 M12 8.4 V9.6"/>
  </symbol>
  <symbol id="ic-upwelling" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4 19 H20"/>
    <path d="M8 19 V9.5 M6.6 11 L8 9.5 L9.4 11"/><path d="M12 19 V6.5 M10.6 8 L12 6.5 L13.4 8"/><path d="M16 19 V10.5 M14.6 12 L16 10.5 L17.4 12"/>
  </symbol>
  <symbol id="ic-forecast" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3.5 12 q3 -3.5 6 0 t6 0"/><path d="M15.5 12 q1.6 -1.9 3.2 0" stroke-dasharray="2 2"/>
    <path d="M18.4 9.6 L20.9 12 L18.4 14.4"/>
  </symbol>

  
  <symbol id="ic-depth" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 5 H19"/><path d="M12 5 V16"/><circle cx="12" cy="18" r="2"/><path d="M7.5 8.5 H9.5 M7.5 12 H9.5 M14.5 8.5 H16.5"/>
  </symbol>
  <symbol id="ic-point" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="6.5"/><path d="M12 2.5 V6 M12 18 V21.5 M2.5 12 H6 M18 12 H21.5"/><circle cx="12" cy="12" r="1.1" fill="currentColor"/>
  </symbol>
  <symbol id="ic-load" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3.5 V13.5"/><path d="M8 10 L12 14 L16 10"/><path d="M5 16.5 V19.5 H19 V16.5"/>
  </symbol>
  <symbol id="ic-save-view" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M6.5 4 H17.5 V20.5 L12 16 L6.5 20.5 Z"/>
  </symbol>
  <symbol id="ic-layers" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 3.5 L20.5 8 L12 12.5 L3.5 8 Z"/><path d="M3.5 12 L12 16.5 L20.5 12"/><path d="M3.5 16 L12 20.5 L20.5 16"/>
  </symbol>
  <symbol id="ic-legend" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M4.5 6 h2 v2 h-2 Z" fill="currentColor"/><path d="M4.5 11 h2 v2 h-2 Z" fill="currentColor"/><path d="M4.5 16 h2 v2 h-2 Z" fill="currentColor"/>
    <path d="M9.5 7 H19.5 M9.5 12 H19.5 M9.5 17 H19.5"/>
  </symbol>
  <symbol id="ic-panel" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="5" width="16" height="14" rx="2"/><path d="M9.5 5 V19"/><path d="M16 9.5 L13 12 L16 14.5"/>
  </symbol>
  <symbol id="ic-org" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M5 20.5 V8.5 L12 4 L19 8.5 V20.5 Z"/><path d="M10.5 20.5 V16 H13.5 V20.5"/>
    <path d="M8 11 H9.5 M14.5 11 H16 M8 14 H9.5 M14.5 14 H16"/>
  </symbol>
  <symbol id="ic-profile" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="8.5" r="3.3"/><path d="M5.5 20 a6.5 6.5 0 0 1 13 0"/>
  </symbol>
  <symbol id="ic-logout" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <path d="M13.5 4.5 H6 V19.5 H13.5"/><path d="M10 12 H20.5 M17.5 9 L20.5 12 L17.5 15"/>
  </symbol>
  <symbol id="ic-calendar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4.5" y="6" width="15" height="14" rx="2"/><path d="M4.5 10 H19.5 M8 4 V7.5 M16 4 V7.5"/><circle cx="12" cy="14.5" r="1" fill="currentColor"/>
  </symbol>
  <symbol id="ic-search" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="11" cy="11" r="6"/><path d="M15.5 15.5 L20 20"/>
  </symbol>
  <symbol id="ic-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="4"/><path d="M12 2.5 V5 M12 19 V21.5 M2.5 12 H5 M19 12 H21.5 M5.4 5.4 L7.1 7.1 M16.9 16.9 L18.6 18.6 M18.6 5.4 L16.9 7.1 M7.1 16.9 L5.4 18.6"/>
  </symbol>
  <symbol id="ic-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="8.5"/><path d="M3.5 12 H20.5"/>
    <path d="M12 3.5 C14.4 6.2 14.4 17.8 12 20.5 C9.6 17.8 9.6 6.2 12 3.5 Z"/>
  </symbol>
</defs>
</svg>`

export function BrandSprite() {
  return (
    <div
      aria-hidden
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      dangerouslySetInnerHTML={{ __html: SPRITE }}
    />
  )
}
